module.exports = __webpack_public_path__ + "img/pleasure-icon-1.b0af3e3b.svg";